import React from 'react';
import ReactDOM from 'react-dom';

export default class Loading extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            text: 'Czekaj - spełniamy Twoje marzenie...'
        };
    }

    componentDidMount() {
        if(typeof this.props.text != "undefined") {
            this.setState({
                text: this.props.text
            })
        }
    }

    render() {
        return (
            <div className="loading-wrapper">
                <div className="loading_booking_engine">
                    <div className="bounce1"></div>
                    <div className="bounce2"></div>
                    <div className="bounce3"></div>
                </div>
                <div className="label_loading">{this.props.text ? this.props.text : this.state.text}</div>
            </div>
        );
    }
}
